import React, { useEffect, useState } from "react";
import api, { mediaUrl } from "@/lib/api";
import { Megaphone } from "@phosphor-icons/react";

export default function AdBanner({ placement = "home", tenant = null }) {
  const [ads, setAds] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get("/ads", { params: { placement, ...(tenant ? { tenant } : {}) } }).then((r) => setAds(r.data)).catch(() => {});
  }, [placement, tenant]);

  useEffect(() => {
    if (ads.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % ads.length), 5000);
    return () => clearInterval(t);
  }, [ads]);

  if (ads.length === 0) return null;
  const ad = ads[idx];

  const visit = async () => {
    try {
      const { data } = await api.post(`/ads/${ad.id}/click`);
      window.open(data.url, "_blank", "noopener");
    } catch {
      window.open(ad.target_url, "_blank", "noopener");
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 pt-8" data-testid="ad-banner">
      <div className="flex items-center gap-2 mb-2">
        <Megaphone size={14} weight="fill" color="#FFD600" />
        <span className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-mono">Advertisement</span>
      </div>
      <button onClick={visit} data-testid="ad-banner-click"
        className="group relative w-full overflow-hidden border-2 border-[#FFD600] block h-36 sm:h-44 hover:shadow-[6px_6px_0px_#FFD600] transition-all">
        <img src={mediaUrl(ad.image_url)} alt={ad.title}
          className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-300" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-transparent" />
        <div className="relative h-full flex flex-col justify-center px-6 sm:px-10 text-left">
          <span className="text-[10px] uppercase tracking-widest text-[#FFD600] font-mono mb-1">Sponsored by {ad.owner_name}{ad.is_mine ? " · Your Ad" : ""}</span>
          <h3 className="font-display text-xl sm:text-3xl font-black uppercase max-w-xl leading-tight">{ad.title}</h3>
        </div>
      </button>
    </div>
  );
}
